export function ComingSoonPlaceholder() {
  return (
    <div className="flex items-center justify-center py-16 text-text-secondary">
      Coming soon
    </div>
  );
}
